import { forwardRef, useEffect, useState, useRef } from "react";
import { instanceOf, string } from "prop-types";

import Modal from "../../../../Common/js/components/Modal/Modal.jsx";

const propTypes = {
  content: instanceOf(HTMLCollection).isRequired, // HTML collection of Elements https://developer.mozilla.org/en-US/docs/Web/API/Element
  name: string.isRequired,
};

const GlobalModal = forwardRef((props, ref) => {
  const { content, name } = props;

  const [modalOpen, setModalOpen] = useState(false);

  const contentRef = useRef();

  window.dataLayer = window.dataLayer || [];

  useEffect(() => {
    if (ref) {
      ref.current = {
        openModal: () => {
          setModalOpen(true);
          window.dataLayer.push({
            event: "form impression",
            "form name": name,
          });
        },
        closeModal: () => setModalOpen(false),
      };
    }
  }, [name, ref]);

  useEffect(() => {
    setTimeout(() => {
      contentRef.current.innerHTML = "";
      [...content].forEach((c) => {
        contentRef.current.append(c);
      });
    }, 0);
  }, [content]);

  return (
    <Modal
      className="modal--form"
      noPadding
      isOpen={modalOpen}
      title={false}
      onClose={() => setModalOpen(false)}
    >
      <div ref={contentRef}></div>
    </Modal>
  );
});

GlobalModal.propTypes = propTypes;
export default GlobalModal;
